import { useEffect, useRef } from 'react';

const bus = new EventTarget();

export function emit(topic, detail = null) {
  if (!topic) return;
  bus.dispatchEvent(new CustomEvent(topic, { detail }));
}

export function subscribe(topic, callback) {
  const handler = (e) => callback(e.detail);
  bus.addEventListener(topic, handler);
  return () => bus.removeEventListener(topic, handler);
}

export function useCatalogSync(topics, callback) {
  const cbRef = useRef(callback);
  cbRef.current = callback;
  useEffect(() => {
    const list = Array.isArray(topics) ? topics : [topics];
    const unsubs = list.map(t => subscribe(t, (detail) => cbRef.current?.(detail, t)));
    return () => unsubs.forEach(u => u());
  }, [Array.isArray(topics) ? topics.join('|') : topics]); // eslint-disable-line react-hooks/exhaustive-deps
}
